import {
    GET_ROUTE_LOADING,
    GET_ROUTE_SUCCESS,
    GET_ROUTE_REJECT,
} from "../../actions/route/getAll";

import {
    GET_ROUTE_DOWLOAND_LOADING,
    GET_ROUTE_DOWLOAND_SUCCESS,
    GET_ROUTE_DOWLOAND_REJECT,
} from "../../actions/route/getAllDowloand";

import {
    GET_ROUTE_ID_LOADING,
    GET_ROUTE_ID_SUCCESS,
    GET_ROUTE_ID_REJECT,
} from "../../actions/route/getId";

import {
    GET_ROUTE_ORDER_ALL_LOADING,
    GET_ROUTE_ORDER_ALL_SUCCESS,
    GET_ROUTE_ORDER_ALL_REJECT,
} from "../../actions/route/getOrderAll";

import {
    GET_ROUTE_COST_ALL_LOADING,
    GET_ROUTE_COST_ALL_SUCCESS,
    GET_ROUTE_COST_ALL_REJECT,
} from "../../actions/route/getCostAll";

import {
    GET_ROUTE_PAYMENT_ALL_LOADING,
    GET_ROUTE_PAYMENT_ALL_SUCCESS,
    GET_ROUTE_PAYMENT_ALL_REJECT,
} from "../../actions/route/getPaymentAll";

import {
    GET_ROUTE_ALL_COORDS_LOADING,
    GET_ROUTE_ALL_COORDS_SUCCESS,
    GET_ROUTE_ALL_COORDS_REJECT,
} from "../../actions/route/getAllCoords";

import {
    GET_ROUTE_HOME_LOADING,
    GET_ROUTE_HOME_SUCCESS,
    GET_ROUTE_HOME_REJECT,
} from "../../actions/route/getDashboard";

import {
    GET_ROUTE_TRACKING_LOADING,
    GET_ROUTE_TRACKING_SUCCESS,
    GET_ROUTE_TRACKING_REJECT,
} from "../../actions/route/trackingRoute";

import {
    POST_ROUTE_ORDER_LOADING,
    POST_ROUTE_ORDER_SUCCESS,
    POST_ROUTE_ORDER_REJECT,
    POST_ROUTE_ORDER_RESET,
} from "../../actions/route/postOrders";

import {
    PUT_ROUTE_ORDER_LOADING,
    PUT_ROUTE_ORDER_SUCCESS,
    PUT_ROUTE_ORDER_REJECT,
    PUT_ROUTE_ORDER_RESET,
} from "../../actions/route/putOrders";

import {
    POST_ROUTE_COST_LOADING,
    POST_ROUTE_COST_SUCCESS,
    POST_ROUTE_COST_REJECT,
    POST_ROUTE_COST_RESET,
} from "../../actions/route/postCost";

import {
    PUT_ROUTE_COST_LOADING,
    PUT_ROUTE_COST_SUCCESS,
    PUT_ROUTE_COST_REJECT,
    PUT_ROUTE_COST_RESET,
} from "../../actions/route/putCost";

import {
    POST_ROUTE_PAYMENT_LOADING,
    POST_ROUTE_PAYMENT_SUCCESS,
    POST_ROUTE_PAYMENT_REJECT,
    POST_ROUTE_PAYMENT_RESET,
} from "../../actions/route/postPayment";

import {
    PUT_ROUTE_PAYMENT_LOADING,
    PUT_ROUTE_PAYMENT_SUCCESS,
    PUT_ROUTE_PAYMENT_REJECT,
    PUT_ROUTE_PAYMENT_RESET,
} from "../../actions/route/putPayment";

import {
    POST_ROUTE_LOADING,
    POST_ROUTE_SUCCESS,
    POST_ROUTE_REJECT,
    POST_ROUTE_RESET,
} from "../../actions/route/post";

import {
    PUT_ROUTE_LOADING,
    PUT_ROUTE_SUCCESS,
    PUT_ROUTE_REJECT,
    PUT_ROUTE_RESET,
} from "../../actions/route/put";

import {
    PUT_LIQ_ORDER_ROUTE_LOADING,
    PUT_LIQ_ORDER_ROUTE_SUCCESS,
    PUT_LIQ_ORDER_ROUTE_REJECT,
    PUT_LIQ_ORDER_ROUTE_RESET,
} from "../../actions/route/putLiquidate";

import {
    DELETE_ROUTE_LOADING,
    DELETE_ROUTE_SUCCESS,
    DELETE_ROUTE_REJECT,
    DELETE_ROUTE_RESET,
} from "../../actions/route/delete";

import {
    DELETE_ROUTE_PAYMENT_RESET,
    DELETE_ROUTE_PAYMENT_LOADING,
    DELETE_ROUTE_PAYMENT_SUCCESS,
    DELETE_ROUTE_PAYMENT_REJECT, 
} from "../../actions/route/deletePayment";

import {
    DELETE_ROUTE_COST_RESET,
    DELETE_ROUTE_COST_LOADING,
    DELETE_ROUTE_COST_SUCCESS,
    DELETE_ROUTE_COST_REJECT, 
} from "../../actions/route/deleteCost";

import {
    POST_ROUTE_DELIVERY_POINT_LOADING,
    POST_ROUTE_DELIVERY_POINT_SUCCESS,
    POST_ROUTE_DELIVERY_POINT_REJECT,
    POST_ROUTE_DELIVERY_POINT_RESET,
} from "../../actions/route/postDeliveryPoint";

import {
    GET_ROUTE_ID_DP_START_LOADING,
    GET_ROUTE_ID_DP_START_SUCCESS,
    GET_ROUTE_ID_DP_START_REJECT
} from "../../actions/route/getDPStartAll";

import {
    GET_ROUTE_ID_DP_END_LOADING,
    GET_ROUTE_ID_DP_END_SUCCESS,
    GET_ROUTE_ID_DP_END_REJECT
} from "../../actions/route/getDPEndAll";

import {
    PUT_ROUTE_STATUS_LOADING,
    PUT_ROUTE_STATUS_SUCCESS,
    PUT_ROUTE_STATUS_REJECT,
    PUT_ROUTE_STATUS_RESET,
} from "../../actions/route/putStatusRoute";

import {
    POST_NEW_DELIVERY_POINT_ROUTE_LOADING,
    POST_NEW_DELIVERY_POINT_ROUTE_SUCCESS,
    POST_NEW_DELIVERY_POINT_ROUTE_REJECT,
    POST_NEW_DELIVERY_POINT_ROUTE_RESET
} from "../../actions/route/postDeliveryPointTemplate"

import {
    PUT_ROUTE_STATUS_FINISH_LOADING,
    PUT_ROUTE_STATUS_FINISH_SUCCESS,
    PUT_ROUTE_STATUS_FINISH_REJECT,
    PUT_ROUTE_STATUS_FINISH_RESET,
} from "../../actions/route/putStatusFinishRoute";

import {
    PUT_ROUTE_STATUS_FAKESHIPPING_LOADING,
    PUT_ROUTE_STATUS_FAKESHIPPING_SUCCESS,
    PUT_ROUTE_STATUS_FAKESHIPPING_REJECT,
    PUT_ROUTE_STATUS_FAKESHIPPING_RESET,
} from "../../actions/route/putStatusFakeShippingRoute";

import {
    PUT_ROUTE_STATUS_CANCEL_LOADING,
    PUT_ROUTE_STATUS_CANCEL_SUCCESS,
    PUT_ROUTE_STATUS_CANCEL_REJECT,
    PUT_ROUTE_STATUS_CANCEL_RESET,
} from "../../actions/route/putStatusCancelRoute";

import {
    PUT_ROUTE_STATUS_START_LOADING,
    PUT_ROUTE_STATUS_START_SUCCESS,
    PUT_ROUTE_STATUS_START_REJECT,
    PUT_ROUTE_STATUS_START_RESET,
} from "../../actions/route/putStatusStartRoute";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    orderAll: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    costAll: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    paymentAll: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    coordsAll: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    dashboard: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    tracking: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: [],
    },
    postOrder: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putOrder: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    postCost: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putCost: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    postPayment: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putPayment: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    put: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putLiquidateOrder: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    delete: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    deletePayment: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    deleteCost: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    postDeliveryPoint: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putStatus: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    deliveryPointStart: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    deliveryPointEnd: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    routesDowloand: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    postDeliveryPointRouteTemplate: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putStatusFinish: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putStatusFakeShipping: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putStatusCancel: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    putStatusStart: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
}

const routeReducer = (state = stateInit, action) => {
    switch (action.type) {
        // ------------- GET ALL --------------------
        case GET_ROUTE_LOADING: return {
            ...state,
            isLoading: true,
            isSuccess: false,
            isReject: false,
            data: [],
            error: {},
        }
        case GET_ROUTE_SUCCESS: return {
            ...state,
            isLoading: false,
            isSuccess: true,
            isReject: false,
            error: {},
            ...action.payload,
        }
        case GET_ROUTE_REJECT: return {
            ...state,
            isLoading: false,
            isSuccess: false,
            isReject: true,
            data: [],
            error: action.payload?.response?.data
        }

        // ------------- GET ID ID --------------------
        case GET_ROUTE_ID_LOADING: return {
            ...state,
            detail: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_ROUTE_ID_SUCCESS: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_ID_REJECT: return {
            ...state,
            detail: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: null,
                error: action.payload?.response?.data
            }
        }

        // ------------- GET ORDER ALL --------------------
        case GET_ROUTE_ORDER_ALL_LOADING: return {
            ...state,
            orderAll: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_ORDER_ALL_SUCCESS: return {
            ...state,
            orderAll: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_ORDER_ALL_REJECT: return {
            ...state,
            orderAll: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

        // ------------- GET COST ALL --------------------
        case GET_ROUTE_COST_ALL_LOADING: return {
            ...state,
            costAll: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_COST_ALL_SUCCESS: return {
            ...state,
            costAll: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_COST_ALL_REJECT: return {
            ...state,
            costAll: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

          // ------------- GET PAYMENT ALL --------------------
          case GET_ROUTE_PAYMENT_ALL_LOADING: return {
            ...state,
            paymentAll: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_PAYMENT_ALL_SUCCESS: return {
            ...state,
            paymentAll: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_PAYMENT_ALL_REJECT: return {
            ...state,
            paymentAll: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }
        // ------------- GET ORDER ALL --------------------
        case GET_ROUTE_ALL_COORDS_LOADING: return {
            ...state,
            coordsAll: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_ALL_COORDS_SUCCESS: return {
            ...state,
            coordsAll: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_ALL_COORDS_REJECT: return {
            ...state,
            coordsAll: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

        // ------------- GET DASHBOARD --------------------
        case GET_ROUTE_HOME_LOADING: return {
            ...state,
            dashboard: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_HOME_SUCCESS: return {
            ...state,
            dashboard: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_HOME_REJECT: return {
            ...state,
            dashboard: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

        // ------------- GET TRACKING --------------------
        case GET_ROUTE_TRACKING_LOADING: return {
            ...state,
            tracking: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_TRACKING_SUCCESS: return {
            ...state,
            tracking: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_TRACKING_REJECT: return {
            ...state,
            tracking: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }


        // ------------- POST ORDER --------------------
        case POST_ROUTE_ORDER_LOADING: return {
            ...state,
            postOrder: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_ROUTE_ORDER_SUCCESS: return {
            ...state,
            postOrder: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_ROUTE_ORDER_REJECT: return {
            ...state,
            postOrder: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_ROUTE_ORDER_RESET: return {
            ...state,
            postOrder: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        // ------------- PUT ORDER --------------------
        case PUT_ROUTE_ORDER_LOADING: return {
            ...state,
            putOrder: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_ORDER_SUCCESS: return {
            ...state,
            putOrder: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_ORDER_REJECT: return {
            ...state,
            putOrder: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_ORDER_RESET: return {
            ...state,
            putOrder: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- POST COST --------------------
        case POST_ROUTE_COST_LOADING: return {
            ...state,
            postCost: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_ROUTE_COST_SUCCESS: return {
            ...state,
            postCost: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_ROUTE_COST_REJECT: return {
            ...state,
            postCost: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_ROUTE_COST_RESET: return {
            ...state,
            postCost: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT COST --------------------
        case PUT_ROUTE_COST_LOADING: return {
            ...state,
            putCost: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_COST_SUCCESS: return {
            ...state,
            putCost: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_COST_REJECT: return {
            ...state,
            putCost: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_COST_RESET: return {
            ...state,
            putCost: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }


         // ------------- POST PAYMENT --------------------
         case POST_ROUTE_PAYMENT_LOADING: return {
            ...state,
            postPayment: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_ROUTE_PAYMENT_SUCCESS: return {
            ...state,
            postPayment: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_ROUTE_PAYMENT_REJECT: return {
            ...state,
            postPayment: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_ROUTE_PAYMENT_RESET: return {
            ...state,
            postPayment: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT PAYMENT --------------------
        case PUT_ROUTE_PAYMENT_LOADING: return {
            ...state,
            putPayment: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_PAYMENT_SUCCESS: return {
            ...state,
            putPayment: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_PAYMENT_REJECT: return {
            ...state,
            putPayment: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_PAYMENT_RESET: return {
            ...state,
            putPayment: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- POST --------------------
        case POST_ROUTE_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_ROUTE_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_ROUTE_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_ROUTE_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT --------------------
        case PUT_ROUTE_LOADING: return {
            ...state,
            put: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_SUCCESS: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_REJECT: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_RESET: return {
            ...state,
            put: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        // ------------- PUT_LIQ_ORDER_ROUTE --------------------
        case PUT_LIQ_ORDER_ROUTE_LOADING: return {
            ...state,
            putLiquidateOrder: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_LIQ_ORDER_ROUTE_SUCCESS: return {
            ...state,
            putLiquidateOrder: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_LIQ_ORDER_ROUTE_REJECT: return {
            ...state,
            putLiquidateOrder: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_LIQ_ORDER_ROUTE_RESET: return {
            ...state,
            putLiquidateOrder: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- DELETE --------------------
        case DELETE_ROUTE_LOADING: return {
            ...state,
            delete: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_ROUTE_SUCCESS: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_ROUTE_REJECT: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_ROUTE_RESET: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

         // ------------- DELETE ROUTE PAYMENT --------------------
         case DELETE_ROUTE_PAYMENT_LOADING: return {
            ...state,
            deletePayment: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_ROUTE_PAYMENT_SUCCESS: return {
            ...state,
            deletePayment: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_ROUTE_PAYMENT_REJECT: return {
            ...state,
            deletePayment: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_ROUTE_PAYMENT_RESET: return {
            ...state,
            deletePayment: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

         // ------------- DELETE ROUTE COST --------------------
         case DELETE_ROUTE_COST_LOADING: return {
            ...state,
            deleteCost: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_ROUTE_COST_SUCCESS: 
        return {
            ...state,
            deleteCost: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_ROUTE_COST_REJECT: return {
            ...state,
            deleteCost: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_ROUTE_COST_RESET: return {
            ...state,
            deleteCost: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- POST DELIVERY POINT --------------------
        case POST_ROUTE_DELIVERY_POINT_LOADING: return {
            ...state,
            postDeliveryPoint: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_ROUTE_DELIVERY_POINT_SUCCESS: return {
            ...state,
            postDeliveryPoint: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_ROUTE_DELIVERY_POINT_REJECT: return {
            ...state,
            postDeliveryPoint: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_ROUTE_DELIVERY_POINT_RESET: return {
            ...state,
            postDeliveryPoint: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

         // ------------- PUT STATUS --------------------
         case PUT_ROUTE_STATUS_LOADING: return {
            ...state,
            putStatus: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_STATUS_SUCCESS: return {
            ...state,
            putStatus: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_STATUS_REJECT: return {
            ...state,
            putStatus: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_STATUS_RESET: return {
            ...state,
            putStatus: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- GET ALL DELIVERY POINT START --------------------
        case GET_ROUTE_ID_DP_START_LOADING: return {
            ...state,
            deliveryPointStart: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_ROUTE_ID_DP_START_SUCCESS: return {
            ...state,
            deliveryPointStart: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_ID_DP_START_REJECT: return {
            ...state,
            deliveryPointStart: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

        // ------------- GET ALL DELIVERY POINT END --------------------
        case GET_ROUTE_ID_DP_END_LOADING: return {
            ...state,
            deliveryPointEnd: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case GET_ROUTE_ID_DP_END_SUCCESS: return {
            ...state,
            deliveryPointEnd: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_ID_DP_END_REJECT: return {
            ...state,
            deliveryPointEnd: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }

        //--------------------- GET ROUTES DOWLOAND --------------------
        case GET_ROUTE_DOWLOAND_LOADING: return {
            ...state,
            routesDowloand: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: [],
                error: {},
            }
        }
        case GET_ROUTE_DOWLOAND_SUCCESS: return {
            ...state,
            routesDowloand: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case GET_ROUTE_DOWLOAND_REJECT: return {
            ...state,
            routesDowloand: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: [],
                error: action.payload?.response?.data
            }
        }

        // ------------- POST DELIVERY POINT TEMPLATE--------------------
        case POST_NEW_DELIVERY_POINT_ROUTE_LOADING: return {
            ...state,
            postDeliveryPointRouteTemplate: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_NEW_DELIVERY_POINT_ROUTE_SUCCESS: return {
            ...state,
            postDeliveryPointRouteTemplate: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_NEW_DELIVERY_POINT_ROUTE_REJECT: return {
            ...state,
            postDeliveryPointRouteTemplate: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_NEW_DELIVERY_POINT_ROUTE_RESET: return {
            ...state,
            postDeliveryPointRouteTemplate: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT STATUS FINISH --------------------
        
        case PUT_ROUTE_STATUS_FINISH_LOADING: return {
            ...state,
            putStatusFinish: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_STATUS_FINISH_SUCCESS: return {
            ...state,
            putStatusFinish: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_STATUS_FINISH_REJECT: return {
            ...state,
            putStatusFinish: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_STATUS_FINISH_RESET: return {
            ...state,
            putStatusFinish: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT STATUS FAKE SHIPPING --------------------
        case PUT_ROUTE_STATUS_FAKESHIPPING_LOADING: return {
            ...state,
            putStatusFakeShipping: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_STATUS_FAKESHIPPING_SUCCESS: return {
            ...state,
            putStatusFakeShipping: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_STATUS_FAKESHIPPING_REJECT: return {
            ...state,
            putStatusFakeShipping: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_STATUS_FAKESHIPPING_RESET: return {
            ...state,
            putStatusFakeShipping: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT STATUS CANCEL ROUTE --------------------
        case PUT_ROUTE_STATUS_CANCEL_LOADING: return {
            ...state,
            putStatusCancel: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_STATUS_CANCEL_SUCCESS: return {
            ...state,
            putStatusCancel: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_STATUS_CANCEL_REJECT: return {
            ...state,
            putStatusCancel: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_STATUS_CANCEL_RESET: return {
            ...state,
            putStatusCancel: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- PUT STATUS START ROUTE --------------------
        case PUT_ROUTE_STATUS_START_LOADING: return {
            ...state,
            putStatusStart: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case PUT_ROUTE_STATUS_START_SUCCESS: return {
            ...state,
            putStatusStart: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case PUT_ROUTE_STATUS_START_REJECT: return {
            ...state,
            putStatusStart: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case PUT_ROUTE_STATUS_START_RESET: return {
            ...state,
            putStatusStart: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        default: return state;
    }
}

export default routeReducer